/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Group, Modal, Text } from "@mantine/core";
import { put } from "aws-amplify/api";
import {
  fetchAuthSession,
  getCurrentUser,
  GetCurrentUserOutput
} from "aws-amplify/auth";
import { useState } from "react";
import { appShowNotification } from "../../utils/utils";
type confirmDeleteCaseProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  patientCase: any;
  fetchCases: () => void;
};

const ConfirmDeleteCaseModal = (props: confirmDeleteCaseProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { modalOpened, setModalOpened, patientCase, fetchCases } = props;
  const deletePatientRequest = async () => {
    setIsLoading(true);
    const user: GetCurrentUserOutput = await getCurrentUser();
    const { identityId } = await fetchAuthSession();
    const init: any = {
      response: true,
      headers: {},
      body: {
        case: patientCase,
        username: user.username,
        userIdentityId: identityId
      }
    };
    try {
      const deleteCaseResult = put({
        apiName: "DeleteCase",
        path: `/case/${patientCase.id}`,
        options: init
      });
      await deleteCaseResult.response;
      setIsLoading(false);
      setModalOpened(false);
      setErrorMsg("");
      fetchCases();
      appShowNotification({
        title: "Case deleted successfully!",
        type: "success"
      });
    } catch (err: any) {
      console.log(err);
      appShowNotification({
        title: "Failed to delete!",
        type: "error"
      });
      setErrorMsg(err.message);
    }
    setIsLoading(false);
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(false);
      }}
      title="Delete case"
    >
      <Box>
        <Text fw={400} fz={14}>
          Are you sure you want to delete this case?
        </Text>
        {errorMsg && (
          <Text fw={400} fz={14} c="red">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Group mt="md">
        <Group mt="md">
          <Button variant="default" onClick={() => setModalOpened(false)}>
            No
          </Button>
          <Button loading={isLoading} onClick={() => deletePatientRequest()}>
            Yes
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default ConfirmDeleteCaseModal;
